import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/perDiem/workOrder/${number | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/perDiem/workOrder/:id`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/perDiem/workOrder/${workOrderId}`;
